export default "/_next/static/images/3212101c7442aa09c1d05221c524ac94.svg";